import LevelTag from 'components/shared/LevelTag/LevelTag'
import ProjectPathwayBanner from 'components/shared/ProjectPathwayBanner/ProjectPathwayBanner'
import Tags from 'components/shared/Tags/Tags'
import { getPathwayDetails } from 'helpers/Project'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { addFavourite, removeFavourite } from 'redux/actions/FavouriteActions'
import { Button } from '@raspberrypifoundation/design-system-react'

import './ProjectHeader.scss'

const dispatchFavourite = (
  dispatch,
  favourite,
  authentication,
  locale,
  projectId
) => {
  const authToken =
    authentication && authentication.user
      ? authentication.user.access_token
      : null
  if (authToken) {
    if (favourite) {
      dispatch(removeFavourite(locale, authToken, projectId))
    } else {
      dispatch(addFavourite(locale, authToken, projectId))
    }
  }
}

export const ProjectHeader = ({
  authentication,
  dispatch,
  favourite = false,
  included,
  imageUrl,
  loading,
  projectId,
  title,
  primaryTechnology,
  difficultyLevel,
  technologyLabels,
}) => {
  const { t, i18n } = useTranslation()
  const { slug = null, title: pathwayTitle = null } =
    getPathwayDetails(included)

  const labels = technologyLabels.filter((tl) => tl !== primaryTechnology)

  const toggleFavourite = () =>
    dispatchFavourite(
      dispatch,
      favourite,
      authentication,
      i18n.language,
      projectId
    )

  if (loading) return null

  return (
    <>
      <ProjectPathwayBanner slug={slug} pathwayTitle={pathwayTitle} />
      <div className="c-project-header">
        <div className="c-project-header__info-content">
          <LevelTag
            variant="black"
            level={difficultyLevel}
            technology={primaryTechnology}
          />

          <h1 className="c-project-header__title">{title}</h1>
          {labels.length > 0 && (
            <Tags labels={getTechnologyLabels(labels, t)} />
          )}
          {authentication?.user && (
            <Button
              type="secondary"
              className="c-project-header__favourite-button"
              onClick={toggleFavourite}
              icon={favourite ? 'close' : 'check'}
              text={
                favourite
                  ? t('project.header.favourite.added')
                  : t('project.header.favourite.addto')
              }
            />
          )}
        </div>
        {imageUrl && (
          <figure className="c-project-header__illustration">
            <img alt="" className={`c-project-header__image`} src={imageUrl} />
          </figure>
        )}
      </div>
    </>
  )
}

function getTechnologyLabels(technologyLabels, t) {
  return technologyLabels.map((tl) => t(`general.technology-themes.${tl}`))
}

ProjectHeader.propTypes = {
  authentication: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  favourite: PropTypes.bool,
  imageUrl: PropTypes.string,
  loading: PropTypes.bool,
  included: PropTypes.object,
  projectId: PropTypes.number,
  title: PropTypes.string,
  primaryTechnology: PropTypes.string,
  difficultyLevel: PropTypes.number,
  technologyLabels: PropTypes.array,
}

export default ProjectHeader
